<template>
  <div id="organization_pro_outer">
    <div class="organization-html-content" v-html="content" >
    </div>
    <a href="https://img.shslqxh.com/上海市篮球协会章程202010.pdf" target="_blank" class="organization-download" download="上海市篮球协会章程202010.pdf">上海市篮球协会章程下载&nbsp;<span class="iconfont">&#xe58a;</span></a><br>
    <a href="javascript:void (0);" @click="memberSubmit" class="organization-application">会员申请&nbsp;<span class="iconfont">&#xe6d7;</span></a>
  </div>

</template>

<script>
  // import 'static/shl_protocol.html';
export default {
  name: "MemberRules",
  components: {
  },
  data() {
    return {
      title: '会员介绍',
      content: null,
    }
  },
  mounted() {
    const file = this.loadFile('../../static/shl_member_protocol.html');
    // console.log(file);
    this.content = file;
  },
  computed: {
  },
  methods: {
    memberSubmit() {
      // this.$toast('该功能即将上线，敬请期待！');
      // return;
      let user = this.$store.state.dataStore.getUser();
      let url = null;
      if (user != null) {
        let memberValidDate = user.memberValidDate;
        let isMember = false;
        if (memberValidDate != null) {
          isMember = this.$moment(memberValidDate).isAfter(this.$moment());
        }
        let isTeam = user.isTeam;
        if (isTeam == 1) {
          if (isMember) {
            url = this.$router.resolve({
              name: 'groupMemberVue',
            });
          } else {
            url = this.$router.resolve({
              name: 'groupApplicationVue',
            });
          }
          
        } else {
          if (isMember) { 
            url = this.$router.resolve({
              name: 'personalMemberVue',
            });
          } else {
            url = this.$router.resolve({
              name: 'personalApplicationVue',
            });
          }
        }
      } else {
        url= this.$router.resolve({
          name: 'loginPage',
        });
        // let rediretLocation = this.$router.resolve({
        //   name: 'personalApplicationVue',
        // });
        // this.$store.state.dataStore.setRedirectUrl(rediretLocation.href);
      }
      window.open(url.href,'_blank');
    }
  }
}
</script>

<style scoped>

  #organization_pro_outer {
    text-align: center;
  }

  .organization-html-content {
    min-height: 300px;
    text-align: left;
  }

  .organization-download {
    margin-top: 30px;
    display: inline-block;
    font-size: 1.2rem;
    text-decoration: none;
  }

  .organization-download > span {
    font-size: 1.2rem;
  }

  .organization-application {
    display: block;
    margin-top: 15px;
    display: inline-block;
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: none;
    background-color: #fc1a34;
    color: white;
    padding: 8px 20px;
    border-radius: 30px;
    vertical-align: middle;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/introduce/MemberRules.vue